import { Dialog, DialogActions, DialogContent, TextField } from "@material-ui/core";
import React from "react";
import { Button, useCreateSuggestionContext } from "react-admin";

export const AlternatePnCreateNewItem = ({ choices }) => {
  const { onCancel, onCreate } = useCreateSuggestionContext();
  const [value, setValue] = React.useState("");

  const handleSubmit = event => {
    event.preventDefault();
    const newOption = { id: value, pn: value, isManual: true };
    choices.push(newOption);
    setValue("");
    onCreate(newOption);
  };

  return (
    <Dialog open onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField label="Pn" value={value} onChange={event => setValue(event.target.value)} autoFocus />
        </DialogContent>
        <DialogActions>
          <Button type="submit" label="Save" />
          <Button onClick={onCancel} label="Cancel" />
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AlternatePnCreateNewItem;
